var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#a3a3a3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-883 -171)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12,
    transform: "translate(883 171)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(885 173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.375,4.421,8.669,1.127a.483.483,0,0,0,0-.681L8.381.157a.483.483,0,0,0-.682,0L4.405,3.451,1.111.157a.483.483,0,0,0-.681,0L.141.445a.482.482,0,0,0,0,.681L3.435,4.421.141,7.715a.483.483,0,0,0,0,.682l.289.289a.483.483,0,0,0,.681,0L4.405,5.391,7.7,8.685a.478.478,0,0,0,.341.141h0a.478.478,0,0,0,.341-.141L8.669,8.4a.483.483,0,0,0,0-.681Z",
    transform: "translate(0 -0.016)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.50b4761a071240fe21b65d6febaa06b4.svg";
export { ForwardRef as ReactComponent };